import _ from 'lodash';
import angular from 'angular';
import template from './template.html';
import './style.scss';

export class TypeaheadLocationsComponent {
    constructor($scope, $http, LocationService) {
        this.$scope = $scope;

        $scope.getLocation = function (value) {
            return LocationService.getLocationSuggestions({
                value,
            }).then(({ result: { results: { values: suggestions } } }) => _.map(suggestions, item => ({
                ...item,
                locationName: item.text,
            })));
        };
    }

    $onInit() {
        this.isLocationEditable = _.isEmpty(this.$scope.selected);
        this.inputName = `location-${this.$scope.$id}`;
    }

    $onChanges() {
        this.$scope.selected = this.location.locationName;
    }

    resetLocation() {
        const newValue = {};
        this.onChangeParent({ $item: newValue });
        this.isLocationEditable = true;
    }

    onOptionsSelected($item) {
        this.onChangeParent({ $item });
        this.isLocationEditable = false;
    }
}

export const config = {
    bindings: {
        isRequired: '<',
        location: '<',
        parentForm: '<',
        onChangeParent: '&',
    },
    controller: TypeaheadLocationsComponent,
    template,
    controllerAs: 'ctrl',
};

angular
    .module('TALENYA-FE')
    .component('typeaheadLocationsComponent', config);
